import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

const studentRegistrationSuccess = (data) => {
  return {
    type: actionTypes.POST_STUDENT_REGISTRATION,
    payload: {
      student: data.Data,
    },
  };
};

export const studentRegistration = (student) => async (dispatch) => {

  return await apiCall
    .axiosPost(`${API_BASE_URL}/StudentRegistration`, student)
    .then((response) => {
      if (response) {
        dispatch(studentRegistrationSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};